// PhoneInput — drop-in for <input> on phone-number fields. Formats as the
// user types ("(248) 560-5540"), stores the formatted value in parent state,
// and otherwise behaves like a normal controlled input.
//
// Usage:
//   <PhoneInput value={form.salesRepPhone}
//               onChange={(v) => set("salesRepPhone", v)}
//               placeholder="(248) 555-1234" />

import React from "react";
import { formatPhone } from "../utils/phone";

export default function PhoneInput({
  value,
  onChange,
  placeholder = "(248) 555-1234",
  style,
  className,
  disabled,
  ...rest
}) {
  return (
    <input
      type="tel"
      inputMode="tel"
      autoComplete="tel"
      value={value || ""}
      onChange={(e) => onChange(formatPhone(e.target.value))}
      onBlur={(e) => onChange(formatPhone(e.target.value))}
      placeholder={placeholder}
      style={style}
      className={className}
      disabled={disabled}
      {...rest}
    />
  );
}
